import { gql } from 'graphql-tag';

export const CREATE_HOLD_EVENT = gql`
  mutation createHoldEvent($machineId: String!, $utcEnd: Int, $utcStart: Int) {
    createHoldEvent(machineId: $machineId, utcEnd: $utcEnd, utcStart: $utcStart) {
      eventID
      message
      status
    }
  }
`;
